import React from 'react';
// Static info bar. No countdown, timers or price.
export function InfoBar() {
  return <div className="w-full border-b border-white/10 bg-slate-900 text-stone-50" data-id="element-180" data-mp="2fhl4na9w789l">
      <p className="mx-auto max-w-6xl px-4 py-2.5 text-center text-xs font-medium sm:text-sm" data-id="element-181" data-mp="2fjpgqfhy3dky">
        Engangsbetaling · Digital adgang med det samme · 7 dages garanti
      </p>
    </div>;
}